/**
 * This is the entry file for webpack/config/front.js
 */


// Nette forms
import netteForms from 'nette-forms';
window.Nette = netteForms;
netteForms.initOnLoad();


// Cookies
import '/node_modules/vanilla-cookieconsent/dist/cookieconsent.js';


// Application
import '/webpack/assets/js/youtube.js';
import '/webpack/assets/js/netteFormsExtension.js';
import '/webpack/assets/js/front/general.js';
import '/webpack/assets/js/front/news.js';
import '/webpack/assets/js/front/teamMember.js';
import '/webpack/assets/js/front/expandableText.js';
import '/webpack/assets/js/front/expandableRowKeyText.js';
import '/webpack/assets/js/front/expandableRowList.js';
